import { getData, postData } from '@/services/api.service';
import React, { useEffect, useState } from 'react';
import Spinner from './Components/spinner';
import { theme_5 } from '@/utils/constants';
import { useNavigate } from 'react-router';
import { routes } from '@/utils/routes/routes';
import { toast } from 'react-toastify';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '@/core/redux/store';
import { setTemplateImages } from '@/core/redux/commonSlice';
import Home3Edit from './home-3/edit';
import Home5Edit from './home-5/edit';
import Home4Edit from './home-4/edit';
import Home1Edit from './home-1/edit';
import Home2Edit from './home-2/edit';

const HomeEdit = () => {
  const dispatch = useDispatch();
  const headerData = useSelector((state: RootState) => state.common.header);
  const [themeData, setThemeData] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [homeTheme] = useState(headerData?.template);
  // const [homeTheme] = useState(5);

  const fetchThemeEdit = async () => {
    const url = new URL(window.location.href);
    const token = url.searchParams.get('token');
    try {
      const payload = {
        token: token,
      };
      const response = await postData('validate_token', payload);
      if (response.status == 200 || response.status == 201) {
        fetchData();
      } else {
        // Navigate to home page if token is invalid
        navigate(routes.home);
      }
    } catch (err) {
      if (err?.status == 400) {
        // Navigate to home page if token is invalid
        navigate(routes.home);
      }
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await getData('get_cms_json');
      if (response.status == 200 || response.status == 201) {
        const parsedData = response?.data?.data?.cms_json != ''
          ? JSON.parse(response?.data?.data?.cms_json)
          : theme_5;
        
        setThemeData(parsedData);
        
        // Set template_images in Redux - it's at the top level of the response, not inside cms_json
        const templateImages = response?.data?.data?.template_images;
        if (templateImages && typeof templateImages === 'object') {
          dispatch(setTemplateImages(templateImages));
        }
        
        // setThemeData(theme_5);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchThemeEdit();
  }, []);

  useEffect(() => {
    if (homeTheme == '1') {
      import('../assets/css/style1.css');
    } else if (homeTheme == '2') {
      import('../assets/css/style2.css');
    } else if (homeTheme == '3') {
      import('../assets/css/style3.css');
    } else if (homeTheme == '4') {
      import('../assets/css/style4.css');
    } else if (homeTheme == '5') {
      import('../assets/css/style5.css');
    }
  }, []);

  return (
    <>
      {loading ? (
        <Spinner />
      ) : (
        <>
          {homeTheme == '1' ? (
            <Home1Edit themeData={themeData} fetchData={fetchData} />
          ) : homeTheme == '2' ? (
            <Home2Edit themeData={themeData} fetchData={fetchData} />
          ) : homeTheme == '3' ? (
            <Home3Edit themeData={themeData} fetchData={fetchData} />
          ) : homeTheme == '4' ? (
            <Home4Edit themeData={themeData} fetchData={fetchData} />
          ) : homeTheme == '5' ? (
            <Home5Edit themeData={themeData} fetchData={fetchData} />
          ) : null}
        </>
      )}
    </>
  );
};

export default HomeEdit;
